/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getNetwork } from "loraactions/tdm";
import Network from "./Network";
import Node from "./Node";
import Gateway from "./Gateway";
import Pairs from "./Pairs";
import { parseContent } from "./util";
import styles from "./styles.scss";

const propTypes = {
  getNetwork: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
  networkDetail: PropTypes.object.isRequired,
  action: PropTypes.string.isRequired,
};

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      network: "",
    };
    this.onChangeNetwork = this.onChangeNetwork.bind(this);
  }

  componentDidMount() {
    const { networkDetail, typesJSON } = this.props;
    this.initNetwork(networkDetail, typesJSON);
  }

  componentWillReceiveProps({ networkDetail, typesJSON }) {
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.initNetwork(networkDetail, typesJSON);
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      this.initNetwork(networkDetail, typesJSON);
    }
  }

  onChangeNetwork(network) {
    this.setState({ network });
    this.props.getNetwork();
  }

  initNetwork(networkDetail, typesJSON) {
    const { name } = networkDetail.data || {};
    const { types } = parseContent(typesJSON);
    if (name && types.networktypes) {
      const nwks = _.find(
        types.networktypes,
        (n) => n.networks && n.networks.name === name
      );
      if (nwks && nwks.networks) {
        this.setState({ network: nwks.networks.name });
      }
    }
  }

  render() {
    const { network } = this.state;

    return (
      <div className={styles.tdm}>
        <Network onSubmitted={this.onChangeNetwork} network={network} />
        <Node network={network} routerAction={this.props.action} />
        <Gateway network={network} routerAction={this.props.action} />
        <Pairs network={network} routerAction={this.props.action} />
      </div>
    );
  }
}

Detail.propTypes = propTypes;

const mapStateToProps = (state, { location: { action } }) => ({
  action,
  typesJSON: state.tdm.setting,
  networkDetail: state.tdm.getNetwork,
});

const mapDispatchToProps = {
  getNetwork,
};

export default connect(mapStateToProps, mapDispatchToProps)(Detail);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Detail.jsx